"use strict";
var validation_messages_component_1 = require("./validation-messages.component");
exports.ValidationMessagesComponent = validation_messages_component_1.ValidationMessagesComponent;
var validation_messages_module_1 = require("./validation-messages.module");
exports.BhtpValidationMessagesModule = validation_messages_module_1.BhtpValidationMessagesModule;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validation-messages/index.js